// extracted by mini-css-extract-plugin
export default {"search":"Search_search__NPsdM","button":"Search_button__2kjAM"};